import { jsx as o, jsxs as h } from "react/jsx-runtime";
import { useId as d } from "react";
import { Z as f } from "../index-Dlw4JYvo.js";
import { c as r } from "../clsx-OuTLNxxd.js";
import '../List.css';const k = "_list_186i9_1", m = "_listItem_186i9_10", T = "_listItemText_186i9_16", W = "_iconWrapper_186i9_20", u = "_check_186i9_28", i = {
  list: k,
  listItem: m,
  listItemText: T,
  iconWrapper: W,
  check: u,
  "size--s": "_size--s_186i9_32",
  "size--m": "_size--m_186i9_44"
}, b = ({ classNames: t, direction: e, items: _, size: n = "m", ...p }) => {
  const c = d(), I = e ? { flexDirection: e } : {};
  return /* @__PURE__ */ o(
    "ul",
    {
      className: r(i.list, i[`size--${n}`], t == null ? void 0 : t.wrapper),
      "data-cxy-name": "list",
      style: I,
      ...p,
      children: _.map((x, l) => /* @__PURE__ */ h("li", { className: r(i.listItem, t == null ? void 0 : t.listItem), children: [
        /* @__PURE__ */ o("span", { className: r(i.iconWrapper, t == null ? void 0 : t.iconWrapper), children: /* @__PURE__ */ o(f, { className: r(i.check, t == null ? void 0 : t.checkIcon), color: "blue", size: n }) }),
        /* @__PURE__ */ o("span", { className: r(i.listItemText, t == null ? void 0 : t.listItemText), children: x })
      ] }, `list-${c}-item-${l}`))
    }
  );
};
export {
  b as List
};
